import {problemActionConfig} from "../config/ProblemActionConfig";

export const fetchproblemActionConfig = (problemAction, dispatch, nextAction) => {
    const config = problemActionConfig[problemAction]
    dispatch({
        type: nextAction,
        data: config
    })
}